import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import MultiSelector from "./MultiSelector"
import "./RegionMultiSelector.css"
import Checkbox from "../Checkbox/Checkbox"

class RegionMultiSelector extends PureComponent {
  renderLocationOptions = () => {
    const { handleChange, locationOptions, locationFilters } = this.props
    if (locationOptions) {
      return locationOptions.map(o => (
        <li key={o.value}>
          <Checkbox
            label={o.label}
            id={o.label}
            onClick={() => handleChange(o, "location")}
            checked={locationFilters.some(f => f.value === o.value)}
            radio
          />
        </li>
      ))
    }
  }

  renderCityOptions = () => {
    const { handleChange, regionOptions, regionFilters } = this.props
    if (regionOptions) {
      return regionOptions.map(o => (
        <li key={o.value}>
          <Checkbox
            label={o.label}
            id={o.label}
            onClick={() => handleChange(o, "region")}
            checked={regionFilters.some(f => f.value === o.value)}
          />
        </li>
      ))
    }
    return null
  }

  render() {
    const { handleChange, regionFilters, locationFilters, showRegionNotSelectedInfo, ...rest } = this.props
    return (
      <div className="region-selector-wrapper">
        <MultiSelector
          text="Kunta"
          filters={regionFilters}
          filter="region"
          {...rest}
        >
          {showRegionNotSelectedInfo ? (
            <p className="region-info-top">Valitse jokin allaolevista vaihtoehdoista ennen hakua:</p>
          ) : null}
          <ul>{this.renderLocationOptions()}</ul>
          <p className="region-subtitle">Kunta</p>
          <p className="region-info">
            Voit rajata tuloksia tarkemmin kunnan perusteella.
          </p>
          <ul>{this.renderCityOptions()}</ul>
        </MultiSelector>
      </div>
    )
  }
}

RegionMultiSelector.propTypes = {
  toggleSelector: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  filters: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  clearFilters: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape()),
}

export default RegionMultiSelector
